(function() {
  const sections = document.querySelectorAll('.bigmad-stores');
  if (!sections.length) return;

  sections.forEach(section => {
    const tabs = section.querySelectorAll('[data-tab-target]');
    const cards = section.querySelectorAll('[data-tab-panel]');

    if (!tabs.length || !cards.length) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tabTarget;
        if (!target) return;

        // Atualiza estado das tabs
        tabs.forEach(t => {
          const isActive = t.dataset.tabTarget === target;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        // Atualiza cards visíveis
        cards.forEach(card => {
          const isActive = card.dataset.tabPanel === target;
          card.classList.toggle('is-active', isActive);
          card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        // Scroll horizontal pra tab clicada (mobile)
        if (window.matchMedia('(max-width: 989px)').matches) {
          tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });
  });
})();